import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapMembersAthletesComponent } from './bootstrap-members-athletes/bootstrap-members-athletes.component';

const routes: Routes = [{
  path: '', component: BootstrapMembersAthletesComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MembersAthletesRoutingModule { }
